import { chapterStats } from "@/mocks/chapters";

const stats = [
  {
    icon: "ri-book-open-line",
    label: "主篇规模",
    value: chapterStats.total,
    note: "全程追踪",
  },
  {
    icon: "ri-file-list-3-line",
    label: "已整理话数",
    value: chapterStats.covered,
    note: "关键话数收录",
  },
  {
    icon: "ri-compass-3-line",
    label: "剧情阶段",
    value: chapterStats.stage,
    note: "已至完结篇",
  },
  {
    icon: "ri-refresh-line",
    label: "更新状态",
    value: chapterStats.update,
    note: "定期追更整理",
  },
];

export default function ProgressStats() {
  return (
    <section id="progress" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div
            key={s.label}
            className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-500/15 text-accent-600">
              <i className={`${s.icon} text-xl`} />
            </span>
            <div className="min-w-0">
              <p className="text-xs text-foreground-500">{s.label}</p>
              <p className="mt-0.5 truncate font-heading text-base font-bold text-foreground-950">
                {s.value}
              </p>
              <p className="mt-0.5 text-xs text-foreground-400">{s.note}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}